import { render, staticRenderFns } from "./PurchaseOrderTable.vue?vue&type=template&id=0975d202&"
import script from "./PurchaseOrderTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderTable.vue?vue&type=style&index=0&id=0975d202&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports